<!-- Calendar Header -->
<div class="calendar-container">
  <div class="calendar-header">
    <div class="header-controls">
      <!-- Navigation Controls -->
      <div class="nav-controls">
        <button class="nav-btn" (click)="navigateMonth('prev')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M10 12L6 8L10 4"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>

      <!-- Header Display -->
      <div class="month-year" #headerElement>
        <h2 class="header-clickable" (click)="onHeaderClick()">{{ currentHeaderText }}</h2>

        <!-- Date Picker Dropdown -->
        <div class="date-picker-dropdown" *ngIf="showDatePicker" #datePickerDropdown>
          <!-- Month View: Month/Year Picker -->
          <div *ngIf="currentView === 'month'" class="month-picker">
            <ng-container
              *ngTemplateOutlet="
                calendarPicker;
                context: { styleClass: 'custom-calendar month-view' }
              "
            ></ng-container>
          </div>

          <!-- Week View: Range Picker -->
          <div *ngIf="currentView === 'week'" class="week-picker">
            <ng-container
              *ngTemplateOutlet="
                calendarPicker;
                context: { styleClass: 'custom-calendar week-view' }
              "
            ></ng-container>
            <div class="week-selection-info">
              <p>Click on any date to select that week</p>
            </div>
          </div>

          <!-- Day View: Single Date Picker -->
          <div *ngIf="currentView === 'day'" class="day-picker">
            <ng-container
              *ngTemplateOutlet="
                calendarPicker;
                context: { styleClass: 'custom-calendar day-view' }
              "
            ></ng-container>
          </div>
        </div>
      </div>

      <!-- Right Navigation -->
      <div class="nav-controls">
        <button class="nav-btn" (click)="navigateMonth('next')" type="button">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M6 4L10 8L6 12"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>

    <!-- View Toggle -->
    <div class="view-toggle">
      <div class="segment-control">
        <button
          class="segment-btn"
          [class.active]="currentView === 'day'"
          (click)="changeView('day')"
          type="button"
        >
          Day
        </button>
        <button
          class="segment-btn"
          [class.active]="currentView === 'week'"
          (click)="changeView('week')"
          type="button"
        >
          Week
        </button>
        <button
          class="segment-btn"
          [class.active]="currentView === 'month'"
          (click)="changeView('month')"
          type="button"
        >
          Month
        </button>
      </div>
    </div>
  </div>

  <!-- Calendar Body -->
  <div class="calendar-body" #calendarBody>
    <div class="calendar-body-content" [ngClass]="{ 'week-view-expanded': currentView === 'week' }">
      <div *ngIf="isLoading" class="loading-overlay">
        <p>Loading appointments...</p>
      </div>
      <!-- Week Type Selector (only show when week view is active) -->
      <div class="week-type-selector" *ngIf="currentView === 'week'">
        <div class="week-type-control">
          <button
            class="week-type-btn"
            [class.active]="weekType === 'full'"
            (click)="changeWeekType('full')"
            type="button"
          >
            Week
          </button>
          <button
            class="week-type-btn"
            [class.active]="weekType === 'work'"
            (click)="changeWeekType('work')"
            type="button"
          >
            Work Week
          </button>
        </div>
      </div>
      <div class="calendar-grid-scroll">
        <!-- CWS-847: [options] was dropped by the PrimeNG->Material migration commit even
             though full-calendar is unrelated to PrimeNG. Without it, CalendarOptions
             (initialView, plugins, views) never reaches FullCalendar's Calendar instance,
             which then throws viewType "" is not available. -->
        <full-calendar
          #calendar
          [options]="calendarOptions"
          [style.visibility]="isLoading ? 'hidden' : 'visible'"
        >
        </full-calendar>
      </div>
    </div>
  </div>
</div>

<!-- Custom Event Template (Hidden, used for reference) -->
<div class="event-templates" style="display: none">
  <div class="event-card event-confirmed">
    <div class="event-bar"></div>
    <div class="event-body">
      <div class="event-content">
        <span class="event-title">APT 9876540</span>
        <div class="event-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <circle cx="6" cy="6" r="6" fill="#22C55E" />
            <path
              d="M3.5 6L5.5 8L8.5 4"
              stroke="white"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="event-card event-rescheduled">
    <div class="event-bar"></div>
    <div class="event-body">
      <div class="event-content">
        <span class="event-title">APT 3210987</span>
        <div class="event-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1.5 6A4.5 4.5 0 0 1 6 1.5V3L8 1L6 0V1.5A6 6 0 0 0 0 6H1.5Z" fill="#1B5BFF" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="event-card event-cancelled">
    <div class="event-bar"></div>
    <div class="event-body">
      <div class="event-content">
        <span class="event-title">APT 2345678</span>
        <div class="event-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1.5 6A4.5 4.5 0 0 1 6 1.5V3L8 1L6 0V1.5A6 6 0 0 0 0 6H1.5Z" fill="#DA1E28" />
          </svg>
        </div>
      </div>
    </div>
  </div>

  <div class="event-card event-pending">
    <div class="event-bar"></div>
    <div class="event-body">
      <div class="event-content">
        <span class="event-title">APT 7654328</span>
        <div class="event-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1.5 6A4.5 4.5 0 0 1 6 1.5V3L8 1L6 0V1.5A6 6 0 0 0 0 6H1.5Z" fill="#717683" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Reschedule Appointment Modal -->
<app-reschedule-appointment-modal
  [isVisible]="isRescheduleModalVisible"
  [appointment]="appointmentToReschedule"
  [droppedDate]="droppedDate"
  [loading]="isRescheduleLoading"
  (closeModal)="onRescheduleModalClose()"
  (updateAppointment)="onRescheduleUpdate($event)"
>
</app-reschedule-appointment-modal>

<!-- Cancel Appointment Confirmation Modal -->
<app-cancel-appointment-modal
  [isVisible]="isCancelModalVisible"
  [appointment]="appointmentToCancel"
  (confirm)="onCancelConfirm($event)"
  (cancel)="onCancelModalClose()"
  (close)="onCancelModalClose()"
>
</app-cancel-appointment-modal>

<!-- Cancellation Reason Modal -->
<app-cancellation-reason-modal
  [isVisible]="isCancellationReasonModalVisible"
  [item]="appointmentToCancel"
  (submit)="onCancelReasonSubmit($event)"
  (close)="onCancellationReasonModalClose()"
>
</app-cancellation-reason-modal>

<!-- Cancellation Success Modal -->
<app-cancellation-success-modal
  [isVisible]="isCancellationSuccessModalVisible"
  (okay)="onCancellationSuccessModalOkay()"
  (createAnother)="onCancellationSuccessModalCreateAnother()"
  (close)="onCancellationSuccessModalClose()"
>
</app-cancellation-success-modal>

<!-- Appointment Details Modal -->
<app-appointment-details-modal
  [isVisible]="isAppointmentDetailsModalVisible"
  [appointment]="selectedAppointmentForModal"
  (close)="closeAppointmentDetailsModal()"
  (appointmentUpdated)="onAppointmentUpdated()"
  (markCompleteAppointment)="onMarkCompleteFromDetailsModal($event)"
  (rescheduleAppointment)="onRescheduleFromDetailsModal($event)"
  (cancelAppointment)="onCancelFromDetailsModal($event)"
>
</app-appointment-details-modal>

<!-- Calendar Picker Template (reused for month, week, and day views) -->
<ng-template #calendarPicker let-styleClass="styleClass">
  <mat-datepicker
    [(ngModel)]="selectedDate"
    [view]="datePickerView"
    [selectionMode]="selectionMode"
    [inline]="true"
    [showTime]="false"
    (onSelect)="onDateSelect($event)"
    [class]="styleClass"
  >
  </mat-datepicker>
</ng-template>
